import {
  Component,
  inject,
  input,
  InputSignal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AlertController, IonButton, IonIcon } from '@ionic/angular/standalone';
import { AlfredClientService } from '../../alfred-client.service';
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';

/**
 * Position the "Afsluiten x" button at the top right corner
 *
 * @example (save the current step, if there is a value)
 * <lib-close-button [formState]="questionFormCtrl.value">
 * </lib-close-button>
 *
 * @example (there is nothing to save)
 * <lib-close-button [confirmClose]="false">
 * </lib-close-button>
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-close-button',
  templateUrl: './close-button.component.html',
  styleUrls: ['./close-button.component.scss'],
  imports: [IonButton, IonIcon],
})
export class CloseButtonComponent {
  private readonly alertCtrl: AlertController = inject(AlertController);
  private readonly alfredClientService: AlfredClientService =
    inject(AlfredClientService);

  /**
   * Optionally provide the formControl of the current step,
   * so we can save the current value if the form is valid
   */
  public readonly formState: InputSignal<UntypedFormControl | undefined> =
    input();

  /**
   * Determine whether to show the confirm dialog when clicking the
   * close button
   */
  public readonly confirmClose: InputSignal<boolean> = input<boolean>(true);

  constructor() {
    addIcons({ close });
  }

  /**
   * Confirm whether the user really wants to close the test
   */
  public onExitQuestionnaire(): void {
    if (
      !this.confirmClose() ||
      !this.alfredClientService.showCloseConfirmation()
    ) {
      this.alfredClientService.cancel();
      return;
    }

    this.alertCtrl
      .create({
        header: 'Afsluiten',
        message:
          'Weet je zeker dat je wilt afsluiten? Je antwoorden worden opgeslagen. ' +
          'Als je op een ander moment verder wilt gaan, ga je verder waar je bent gebleven.',
        buttons: [
          {
            text: 'Nee, bedankt',
            role: 'cancel',
          },
          {
            text: 'Ja, graag',
            handler: (): void => {
              this.alfredClientService.cancel();
            },
          },
        ],
      })
      .then((alert) => alert.present());
  }
}
